<template>
  <C0002Main></C0002Main>
</template>
<script setup>
// import axios from  'axios';
// import C0001Main from "@/components/C0001/C0001Main";
import { provide, readonly, ref} from "vue";

import {useMouse} from "@/assets/js/mouse";
import C0002Main from "@/components/C0002/C0002Main";
let position = useMouse();
provide('dev', readonly(ref(false)))
provide('position', position)
//const opt1 = ref()

const checker = ref('');
provide("checker", readonly(checker))




// const C0001Main = defineAsyncComponent(() => {
//   return new Promise(resolve => {
//     axios.get("./C0001Main.vue").then(resp => {
//       console.log(resp.data)
//       resolve({
//         template: resp.data
//       })
//     })
//   })
// })
// import PlayGround from "@/components/Demo/PlayGround";
// const toggle = ref(false);
</script>
<style lang="sass">
@use "assets/sass/common"

#app
  font-family: common.$font-family
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  +common.no-select

.print
  position: relative
  display: none

.panel-line-height
  +common.middle-line(30px)

.svg-panel
  height: 830px
  width: 1800px
  margin: 0px auto

.svg-item
  width: 180px
  height: 180px
  margin: 0px auto
  transform-origin: 0 0

@media print
  .print
    display: block
  .no-print
    display: none
</style>
